import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types";
import SpinnerLoading from "../../../../components/pageComponents/SpinnerLoading";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import {
    cuadroRequerimientosEditarCampanaAPI,
    cuadroRequerimientosGetDataToEditCampanaAPI,
} from "../../../../consumers/backendApisUrls";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import Campana from "./Campana";
import {CAMPANA_KEYS} from "./campanaKeys";
import {useManageGetRequest} from "../../../../hooks/useManageGetRequest/useManageGetRequest";

const EditarCampana = ({toggleModal, refreshPage, idCampana, isEditable}) => {
    const SECTION_NAME = "RegistrarCampana"
    const [formValuesCampana, setFormValuesCampana] = useState({});

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitForm] = useSubmitForm();
    const [executeManageGet] = useManageGetRequest();


    const init = async () => {
        setIsLoading(true)
        const api = cuadroRequerimientosGetDataToEditCampanaAPI(idCampana);
        await executeManageGet(api, (res) => successGetAllPeriodosCallback(res), false);
        setIsLoading(false);
    }

    const successGetAllPeriodosCallback = ({data}) => {
        setFormValuesCampana({...data})
    }

    const handleSubmitEditar = async (e) => {
        if (e)
            e.preventDefault();
        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = cuadroRequerimientosEditarCampanaAPI();
        payload = getPayload();
        keys = CAMPANA_KEYS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitCallback, true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const getPayload = () => {
        return {
            ...formValuesCampana,
        }
    }

    const successSubmitCallback = async ({data}) => {
        toggleModal();
        await refreshPage();
    }

    useEffect(() => {
        init();
    }, []);

    if (isLoading) return <SpinnerLoading/>

    return (
        <ModalForm
            titulo={isEditable ? "Editar Campaña": "Detalle Campaña"}
            width="800px"
            showModal={toggleModal}
            isSubmitting={isSubmitting}
            saveButtonDisabled={isSubmitting }
            onSubmit={handleSubmitEditar}
            hasSaveButton={isEditable}
        >

            <div className="displayFlexWrap">
                <Campana
                    formValuesCampana={formValuesCampana}
                    setFormValuesCampana={setFormValuesCampana}
                    isCreate={false}
                    isEditable={isEditable}
                    SECTION_NAME={SECTION_NAME}
                    idCampana={idCampana}
                />
            </div>
        </ModalForm>
    );
}

EditarCampana.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}

export default EditarCampana;